/* global _ */

import helpers from '../util/helpers';

export default {
  init() {
    // JavaScript to be fired on all pages

    // Sticky sidebar
    const hotelBookingSidebar = $('.hotel-booking-form-container.sidebar-wrapper');
    if (hotelBookingSidebar.length && $('html').is('.win,.gecko')) { // IE 11 only
      const sidebarPosTop = hotelBookingSidebar.offset().top - hotelBookingSidebar.height();
      const sidebarMaxPaddingTop = hotelBookingSidebar.parent().height() - hotelBookingSidebar.height() + 200;
      const throttleStickySidebar = _.throttle(function() {
        const scrollTop = $(document).scrollTop();
        if (scrollTop > sidebarPosTop) {
          hotelBookingSidebar.css('padding-top', Math.min(Math.max(0, scrollTop - sidebarPosTop), sidebarMaxPaddingTop) + 'px');
        } else {
          hotelBookingSidebar.css('padding-top', 0);
        }
      }, 10);
      $(window).bind('scroll', throttleStickySidebar);
    }

  },
  finalize() {
    // const body = $('body');
    // JavaScript to be fired on all pages, after page specific JS is fired

    // Hotel Booking Form onSubmit
    // $('.hotel-booking-form').submit(function(e) {
    //   if ($(this).find('input.check-in').val().toLowerCase() === '' || $(this).find('input.check-out').val().toLowerCase() === '') {
    //     $(this).find('.date-validator').show();
    //     e.preventDefault();
    //   } else {
    //     $(this).find('.date-validator').hide();
    //   }
    // });

    // Slick featured offers sliders
    const featuredOffersSlider = $('.section-hotel-hp-detail-booking .featured-offers-slider .slider');
    if (featuredOffersSlider.length) {
      featuredOffersSlider.on('init', function() {
        helpers.equalHeightElements('.featured-offers-slider .equal-height');
      });

      featuredOffersSlider.slick({
        dots: false,
        infinite: true,
        arrows: true,
        appendArrows: '.featured-offers-slider .slide-nav',
      }).on('beforeChange', function(e, slick, currentSlide, nextSlide) {
        $('.featured-offers-slider').find('.slide-index').html(nextSlide + 1);
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateHotelHomepage.js